import { useSetRecoilState } from 'recoil';
import { useNavigate } from 'react-router-dom';

import { connectToGameRoom } from '@/realtime/connect-game-room';

import { openModal, closeModal } from '@/use/useModal';
import { isMenuOpenState } from '@/use/useMenuState';

import useExitGame from './useExitGame';
import useStartGame from './useStartGame';

import { getGame } from '@/framework/game';

const useReconnectGame = () => {
  const navigate = useNavigate();
  const setIsMenuOpen = useSetRecoilState(isMenuOpenState);
  const { clearGame } = useExitGame();
  const startGame = useStartGame();

  const reconnectGame = async (gameId: string) => {
    console.log('reconnectToGame');
    /**
     * Exit any previous game if present
     */
    clearGame();

    openModal('connect');

    try {
      await connectToGameRoom(gameId);

      const { type } = await getGame(gameId);
      startGame(gameId, type);
      setIsMenuOpen(false);
      closeModal();
    } catch (err) {
      clearGame();

      openModal('not-found', {
        onRequestClose: () => {
          closeModal();
          navigate('/');
        },
      });

      throw err;
    }
  };

  return reconnectGame;
};

export default useReconnectGame;
